export enum DiaryNotificationSeverity {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export interface DiaryNotification {
  title?: string;
  message: string | undefined;
  severity: DiaryNotificationSeverity;
}

export interface UniqueDiaryNotification extends DiaryNotification {
  guid: string;
  timeout: ReturnType<typeof setTimeout>;
}

export interface NotificationsState {
  notifications: UniqueDiaryNotification[];
}

export const getDefaultNotificationsState = (): NotificationsState => {
  return {
    notifications: [],
  };
};